import React from 'react';
import { stringifyItem, getFilteredItems } from './helpers';
import { GetItemPropsOptions } from 'downshift';
import { IItem } from './interface';
import { DropdownItem } from './dropdown-item';

interface IProps {
    highlightedIndex: number | null;
    getItemProps: (options: GetItemPropsOptions<IItem>) => IItem;
    allHeadingItem: IItem;
    selectedItem: IItem | null;
    heading: string;
    menuItems: IItem[];
    inputValue: string | null;
    ItemComponent: any;
    HeaderItemComponent: any;
    SubHeaderItemComponent: any;
}

export const MenuHeaderItems = ({
    highlightedIndex,
    getItemProps,
    allHeadingItem,
    selectedItem,
    heading,
    menuItems,
    inputValue,
    ItemComponent,
    HeaderItemComponent,
    SubHeaderItemComponent,
}: IProps) => {
    return (
        <>
            <HeaderItemComponent
                isActive={highlightedIndex === 0}
                {...getItemProps({
                    item: allHeadingItem,
                    isSelected: selectedItem ? selectedItem.key === allHeadingItem.key : false,
                    index: 0,
                })}
            >
                {stringifyItem(allHeadingItem)}
            </HeaderItemComponent>
            {menuItems?.length ? (
                <SubHeaderItemComponent>Top {heading}</SubHeaderItemComponent>
            ) : (
                ''
            )}
            {menuItems?.length
                ? (getFilteredItems(inputValue, menuItems) ?? []).map((item, index) => {
                      return (
                          <DropdownItem
                              key={index + 1}
                              index={index + 1}
                              highlightedIndex={highlightedIndex}
                              getItemProps={getItemProps}
                              item={item}
                              selectedItem={selectedItem}
                              ItemComponent={ItemComponent}
                          />
                      );
                  })
                : null}
            {menuItems?.length ? (
                <SubHeaderItemComponent>Alle {heading}</SubHeaderItemComponent>
            ) : null}
        </>
    );
};
